<template>
	<div class="py-6 border-b last:pb-8">
		<div class="flex w-full justify-center my-6 space-x-2">
			<div class="flex flex-col justify-center w-[80px] h-[80px] shrink-0">
				<img
					src="https://cdn11.bigcommerce.com/s-nuj3c/stencil/29299650-2b9e-013d-ca92-06d759ad9f37/e/15c6ecf0-25f0-013d-e4f6-1e7f4d7752a0/img/GiftCertificate.png"
					class="max-w-[80px] max-h-[80px] object-contain rounded-lg"
				/>
			</div>
			<div class="w-full">
				<div class="flex w-full">
					<div class="text-ihh-midnight-gray w-full max-w-52 mr-4">
						<div class="font-semibold text-base text-ihh-dark-salmon">Gift Certificate</div>
					</div>
					<div class="text-ihh-midnight-gray text-lg">${{ certificate.amount?.toFixed(2) }}</div>
				</div>
				<div class="text-ihh-midnight-gray font-semibold pt-2 px-2 text-xs">
					<div>
						<span>{{ `Recipient: ` }}</span>
						<span class="text-ihh-gray font-normal">{{ certificate?.recipient?.name }}</span>
					</div>
					<div>
						<span>{{ `Email: ` }}</span>
						<span class="text-ihh-gray font-normal">{{ certificate?.recipient?.email }}</span>
					</div>
				</div>
			</div>
		</div>

		<div class="flex w-full justify-between text-sm text-ihh-midnight-gray">
			<div class="flex w-32 justify-around max-w-[120px]">
				<button
					@click="emitReduceQty"
					class="shadow shadow-ihh-midnight-gray/20 m-auto flex w-7 h-7 rounded-full drop-shadow-2xl shadow-black bg-white items-center justify-center text-lg font-medium"
				>
					-
				</button>
				<div class="m-auto text-base font-medium">{{ certificate.quantity }}</div>
				<button
					@click="emitIncreaseQty"
					class="shadow shadow-ihh-midnight-gray/20 m-auto flex w-7 h-7 rounded-full drop-shadow-2xl shadow-black bg-white items-center justify-center text-lg font-medium"
				>
					+
				</button>
			</div>
			<div>
				<button
					@click="emitRemoveCert"
					class="flex group w-9 h-9 p-2 justify-around z-10 hover:bg-ihh-slate-gray bg-ihh-gray/20 rounded-full font-bold text-xl text-ihh-midnight-gray"
				>
					<div class="m-auto items-center flex w-full justify-center">
						<div class="rotate-45 absolute rounded bg-ihh-midnight-gray group-hover:bg-ihh-white py-[1px] rounded-lg px-1.5"></div>
						<div class="-rotate-45 rounded bg-ihh-midnight-gray group-hover:bg-ihh-white py-[1px] rounded-lg px-1.5"></div>
					</div>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CartCertificateMobile',
	props: {
		certificate: {
			type: Object,
			required: true,
			validator: (cert) => 'amount' in cert && 'quantity' in cert && 'recipient' in cert,
		},
		index: {
			type: Number,
			required: true,
		},
	},
	methods: {
		emitReduceQty() {
			this.$emit('reduce-qty', this.index)
		},
		emitIncreaseQty() {
			this.$emit('increase-qty', this.index)
		},
		emitRemoveCert() {
			this.$emit('remove-cert', this.index)
		},
	},
}
</script>
